// Full-document render of the anonymous order-STATUS page
// (/orders/<number>/<hash>/): PageSkeleton wrapping the legacy sealy layout --
// the "Your Orders" heading, the shared RichOrderDetail block (the collapsible
// order-summary-details panel + grouped lines with named-status progress bars,
// typed-serialized server-side), the two legacy empty states, and the
// customer-service info block. The track_order_lookup dataLayer events push
// after hydration; the order-details toggle is owned by the shared block's own
// disclosure state (collapsible).
import React from "react";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AnonOrderDocumentTemplate,
): React.JSX.Element => {
    const { order } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section
                id="order-detail"
                className="l-capped-width u-margin-bottom--xl u-full-width-title order-list"
            >
                <h2>Your Orders</h2>

                {/* The empty-order-status modifier is ALWAYS on: the legacy
                    template gated it on `{% if not orders %}`, but the view
                    never defines `orders`, so the class rendered on every
                    request -- including with-order renders -- and the mobile
                    orders-page margins key on it. */}
                <div className="content__copy--full-width content__orders-page content__orders-page--empty-order-status">
                    <div className="orders">
                        <ul className="orders__list">
                            {order.has_order ? (
                                <li className="orders__list-item">
                                    <div className="content__copy--full-width order-summary-wrapper">
                                        <RichOrderDetail
                                            summary={order.summary}
                                            shipped_events={
                                                order.shipped_events
                                            }
                                            unshipped={order.unshipped}
                                            collapsible={true}
                                        />
                                    </div>
                                </li>
                            ) : order.form_is_bound ? (
                                <li className="orders__list-item">
                                    No orders match your search.
                                </li>
                            ) : (
                                <li className="orders__list-item orders__list-item--empty-order-status">
                                    <h2 className="orders__list-item__title orders__list-item__title--empty-order-status">
                                        You haven&apos;t shopped with us.
                                    </h2>
                                    <p className="orders__list-item__copy orders__list-item__copy--empty-order-status">
                                        Please check back after your first
                                        purchase to view your order details.
                                    </p>
                                    <a className="button" href="/">
                                        Shop now
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                {props.cs_info && (
                    <CustomerServiceInfoBlock info={props.cs_info} />
                )}
            </section>
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
